import React from "react";
import { useSalaryAdvanceRequest } from "./shared/useSalaryAdvanceRequest";
import { ViewHistoryForm } from "./shared/ViewHistoryForm";
import { Button, GeneralMessage } from "../../../common/APICommon"; // Added GeneralMessage
import { Input, DateInput, TextArea } from "../../../common/Input";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

function SalaryAdvanceRequest({ user, isHideSideMenu }) {
  const {
    employeeInfo,
    formData,
    handleInputChange,
    submitRequest,
    errorState,
    localToday,
    showHistory,
    setShowHistory,
    requests,
    loading,
    alertProps // Destructured alert states from hook
  } = useSalaryAdvanceRequest(user);

  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace"></div>
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        <div className="TransactionInfo Transaction-Form-Info shadow-xl">
          
          <div className="transaction-header">
            <div className="sub-title row">
              <span className="pr-[5px] text-[#b0b0b0]">{"Transactions > "}</span>
              <span className="border-b border-black">{"Salary Advance Request"}</span>
            </div>
            <div className="transaction-top row justify-between items-center mt-5">
              <h3 className="text-xl font-bold text-blue-900">Salary Advance Request</h3>
              <Button
                icon={<RemoveRedEyeIcon />}
                name="VIEW HISTORY"
                className="bg-cyan-500 hover:bg-cyan-600 border-none"
                onClick={() => setShowHistory(true)}
              />
            </div>
          </div>

          <div className="transaction-body p-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-2">
              {employeeInfo.map((field, idx) => (
                <Input
                  key={idx}
                  label={field.label}
                  value={field.value}
                  isViewOnly={true}
                />
              ))}

              <Input
                label="Salary Advance Amount"
                type="number"
                placeholder="Please enter amount"
                isRequired={true}
                value={formData.amount}
                onChange={(e) => handleInputChange("amount", e.target.value)}
                error={errorState && !formData.amount}
                errorMessage="Please fill up this field"
              />

              <DateInput
                label="Requested Date"
                isRequired={true}
                min={localToday}
                value={formData.dateRequested}
                onChange={(e) => handleInputChange("dateRequested", e.target.value)}
                error={errorState && !formData.dateRequested}
                errorMessage="Please fill up this field"
              />
            </div>

            <div className="mt-4">
              <TextArea
                label="Reason for Salary Advance"
                isRequired={true}
                placeholder="Please enter reason here..."
                value={formData.reason}
                onChange={(e) => handleInputChange("reason", e.target.value)}
                error={errorState && !formData.reason}
                errorMessage="Please provide a reason"
              />
            </div>

            <div className="transaction-form-footer mt-8 flex justify-end">
              <Button
                disabled={loading}
                name={loading ? "SENDING..." : "SEND REQUEST"}
                className="bg-blue-800 hover:bg-blue-900 border-none px-10 py-3 font-bold"
                onClick={submitRequest}
              />
            </div>
          </div>
        </div>
      </div>

      {/* History Modal */}
      <ViewHistoryForm
        isOpen={showHistory}
        onClose={() => setShowHistory(false)}
        requests={requests}
      />

      {/* REUSABLE GENERAL MESSAGE FEEDBACK */}
      <GeneralMessage 
        form={alertProps.showMessage} 
        message={alertProps.message} 
        isSuccess={alertProps.isSuccess} 
      />
    </div>
  );
}

export default SalaryAdvanceRequest;